import { createContext, MutableRefObject } from 'react';

export type FnVoid = () => void;

export type WizardContextProps = {
  totalSteps: number;
  activeStep: number;
  goPrev: FnVoid;
  goNext: FnVoid;
  hasPrev: boolean;
  hasNext: boolean;
};

export type StepContextProps = {
  onPrev: MutableRefObject<FnVoid>;
  onNext: MutableRefObject<FnVoid>;
  handlePrev: (ev?: React.MouseEvent<HTMLButtonElement>) => void;
  handleNext: (ev?: React.MouseEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>) => void;
};

const WizardContext = createContext<Partial<WizardContextProps>>({});
const StepContext = createContext<Partial<StepContextProps>>({});

export { WizardContext, StepContext };
